<template>
  <page-header-wrapper>
    <div class="wave-pick-page erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item label="日期范围"><a-range-picker v-model="dateRange" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="波次号"><a-input v-model="query.waveNo" allow-clear placeholder="波次号" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="出库单号"><a-input v-model="query.outboundNo" allow-clear placeholder="来源销售出库单号" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="仓库"><a-select :value="normalizeWarehouseId(query.warehouseId)" allow-clear show-search option-filter-prop="children" placeholder="全部仓库" @change="value => { query.warehouseId = value || undefined }"><a-select-option v-for="warehouse in warehouseOptions" :key="warehouse.id" :value="warehouse.id">{{ warehouse.label }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="客户"><a-input v-model="query.customerKeyword" allow-clear placeholder="客户编号或名称" @pressEnter="search" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="状态"><a-select v-model="query.pickStatus" allow-clear placeholder="全部"><a-select-option v-for="o in statusOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="拣货员"><a-select v-model="query.pickerUserId" allow-clear show-search option-filter-prop="children" placeholder="全部"><a-select-option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.nickName || user.userName }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="search">查询</a-button><a-button icon="redo" @click="reset">重置</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>波次拣货单</h3><p>销售出库进入 WMS 后按仓库/温区/线路形成波次，登记 SKU 应拣、已拣与复核结果。</p></div>
          <div class="erp-toolbar-actions">
            <a-button icon="download" :disabled="!selectedRowKeys.length" :loading="exporting" @click="doExport">导出</a-button>
            <a-button type="primary" icon="plus" @click="openCreate">新建波次拣货单</a-button>
          </div>
        </div>
        <a-table
          :row-key="rowKey"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          bordered
          size="middle"
          :scroll="{ x: 1500 }"
          :row-selection="rowSelection"
          @change="onPageChange">
          <template slot="number" slot-scope="value, record"><a @click="openDetail(record)">{{ value }}</a></template>
          <template slot="status" slot-scope="value"><a-tag class="erp-status-tag" :color="statusColor(value)">{{ statusText(value) }}</a-tag></template>
          <template slot="qty" slot-scope="value">{{ formatQty(value) }}</template>
          <template slot="planStart" slot-scope="value">{{ value || '—' }}</template>
          <template slot="actions" slot-scope="value, record">
            <a @click="openDetail(record)">查看</a>
            <a-divider type="vertical" />
            <a v-if="exportingId !== String(record.id)" @click.prevent="exportRow(record)">导出</a>
            <span v-else style="color:rgba(0,0,0,.45)">导出中…</span>
            <a-divider type="vertical" />
            <a v-if="printingId !== String(record.id)" @click.prevent="printRow(record)">打印</a>
            <span v-else style="color:rgba(0,0,0,.45)">打印中…</span>
            <template v-if="record.pickStatus === 'pending_pick'">
              <a-divider type="vertical" /><a @click="openDetail(record, true)">编辑</a>
              <a-divider type="vertical" /><a @click="confirmAction('开始拣货', record, startWavePick)">开始拣货</a>
              <a-divider type="vertical" /><a class="erp-danger-link" @click="confirmAction('删除', record, deleteDeliveryWavePick)">删除</a>
            </template>
            <template v-if="record.pickStatus === 'picking'">
              <a-divider type="vertical" /><a @click="openDetail(record, true)">录入拣货</a>
              <a-divider type="vertical" /><a @click="confirmAction('复核完成', record, completeWavePickReview)">复核完成</a>
            </template>
          </template>
        </a-table>
      </div>

      <a-modal
        v-model="outboundPickerVisible"
        title="选择销售出库单"
        width="1180px"
        ok-text="确定并带出商品"
        :confirm-loading="outboundPickerConfirming"
        :mask-closable="false"
        @ok="confirmOutboundPicker">
        <p class="wave-pick-picker-tip">可多选同一仓库下、已审核且尚未生成进行中波次的销售出库单。确认后带出全部出库商品，并可直接填写实拣数量。</p>
        <div class="wave-pick-picker-toolbar">
          <span class="wave-pick-picker-label">仓库</span>
          <a-select
            :value="normalizeWarehouseId(pickerWarehouseId)"
            allow-clear
            show-search
            option-filter-prop="children"
            placeholder="全部仓库"
            style="width: 220px"
            @change="onPickerWarehouseChange">
            <a-select-option v-for="warehouse in warehouseOptions" :key="warehouse.id" :value="warehouse.id">{{ warehouse.label }}</a-select-option>
          </a-select>
          <a-input-search
            v-model="outboundPickerKeyword"
            placeholder="搜索出库单号、客户"
            allow-clear
            style="max-width: 280px"
            @search="loadOutboundPickerList" />
          <a-button icon="reload" @click="loadOutboundPickerList">刷新</a-button>
        </div>
        <a-alert
          v-if="!outboundPickerLoading && !outboundPickerRows.length"
          type="info"
          show-icon
          style="margin-bottom: 12px"
          message="当前没有可加入波次的销售出库单"
          description="需满足：已审核、未作废，且仍有未被进行中波次占用的可拣数量。请到「销售出库单」对未审核单据先执行审核。" />
        <a-table
          :row-key="pickerRowKey"
          :columns="outboundPickerColumns"
          :data-source="outboundPickerRows"
          :loading="outboundPickerLoading"
          :pagination="false"
          bordered
          size="middle"
          :scroll="{ x: 1280, y: 360 }"
          :row-selection="outboundPickerRowSelection">
          <template slot="qty" slot-scope="value">{{ formatQty(value) }}</template>
          <template slot="money" slot-scope="value"><span v-if="value !== null && value !== undefined">¥{{ formatMoney(value) }}</span><span v-else>—</span></template>
          <template slot="auditStatus" slot-scope="value">{{ auditStatusText(value) }}</template>
          <template slot="text" slot-scope="value">{{ value || '—' }}</template>
        </a-table>
      </a-modal>

      <a-drawer
        :visible="drawerVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-doc-drawer baidao-drawer-sample"
        @close="closeDrawer">
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header">
            <div><button class="erp-back-button" type="button" @click="closeDrawer"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看单据' : (form.id ? '编辑单据' : '新建单据') }}</span><h3>{{ form.waveNo || '新建波次拣货单' }}</h3></div>
            <div><a-button @click="closeDrawer">取消</a-button><a-button v-if="editable" type="primary" :loading="saving" @click="save">保存</a-button></div>
          </header>
          <div class="erp-drawer-content">
            <div class="erp-status-strip"><a-tag class="erp-status-tag" :color="statusColor(form.pickStatus)">{{ statusText(form.pickStatus) }}</a-tag><span>{{ statusHint(form.pickStatus) }}</span></div>
            <section class="erp-form-card">
              <div class="erp-section-title"><span class="erp-section-index">01</span><div><h4>基础信息</h4><p>先确定仓库，再多选该仓库的销售出库单；带出商品后可填写实拣数量</p></div></div>
              <div class="erp-base-grid">
                <label><span>波次号</span><a-input :value="form.waveNo || '保存后系统生成'" disabled /></label>
                <label>
                  <span>仓库</span>
                  <a-select
                    v-if="editableDraft"
                    :value="normalizeWarehouseId(form.warehouseId)"
                    allow-clear
                    show-search
                    option-filter-prop="children"
                    placeholder="全部仓库"
                    @change="onFormWarehouseChange">
                    <a-select-option v-for="warehouse in formWarehouseOptions" :key="warehouse.id" :value="warehouse.id">{{ warehouse.label }}</a-select-option>
                  </a-select>
                  <a-input v-else :value="form.warehouseName || '全部仓库'" disabled />
                </label>
                <label><span>客户</span><a-input :value="form.customerName || '—'" disabled /></label>
                <label><span>温区</span><a-input :value="form.tempZone || '—'" disabled /></label>
                <label><span>线路</span><a-input v-model="form.deliveryRoute" :disabled="!editableDraft" placeholder="配送线路" /></label>
                <label><span>拣货员</span><a-select v-model="form.pickerUserId" :disabled="!editableDraft" allow-clear show-search option-filter-prop="children" placeholder="选择拣货员"><a-select-option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.nickName || user.userName }}</a-select-option></a-select></label>
                <label><span>计划开始</span><a-date-picker v-model="form.planStartTime" show-time value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" :disabled="!editableDraft" /></label>
                <label><span>复核方式</span><a-select v-model="form.reviewMethod" :disabled="!editableDraft"><a-select-option value="scan">扫码复核</a-select-option><a-select-option value="manual">人工复核</a-select-option></a-select></label>
                <label class="wide"><span>备注</span><a-input v-model="form.remark" :disabled="!editableDraft" placeholder="作业说明（选填）" /></label>
              </div>
            </section>
            <section class="erp-form-card">
              <div class="wave-pick-section-head">
                <div class="erp-section-title"><span class="erp-section-index">02</span><div><h4>拣货明细</h4><p>由所选销售出库单带出；应拣数量等于出库数量，实拣数量可直接填写</p></div></div>
                <a-button v-if="editableDraft" class="wave-pick-reselect" icon="swap" @click="openOutboundPicker('change')">{{ form.outboundIds.length ? '重新选择出库单' : '选择销售出库单' }}</a-button>
              </div>
              <div v-if="!form.items.length" class="empty-lines">
                <a-empty description="尚未选择销售出库单">
                  <a-button v-if="editableDraft" type="primary" @click="openOutboundPicker('change')">选择销售出库单</a-button>
                </a-empty>
              </div>
              <div v-else class="erp-line-table-wrap">
                <table class="erp-line-table wave-pick-line-table">
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th>来源出库</th>
                      <th>来源销售订单号</th>
                      <th>SKU</th>
                      <th>商品名称</th>
                      <th>商品规格</th>
                      <th>销售单位</th>
                      <th>出库数量</th>
                      <th>应拣数量</th>
                      <th>实拣数量</th>
                      <th>差异</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in form.items" :key="(item.id || item.outboundItemId) + '-' + index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.outboundNo || '—' }}</td>
                      <td>{{ item.sourceOrderNo || '—' }}</td>
                      <td>{{ item.skuCode }}</td>
                      <td>{{ item.skuName }}</td>
                      <td>{{ item.specName || '—' }}</td>
                      <td>{{ item.unitName || '—' }}</td>
                      <td>{{ formatQty(item.outboundQty) }}</td>
                      <td>{{ formatQty(item.qtyToPick) }}</td>
                      <td>
                        <a-input-number v-if="canEditPicked" :value="Number(item.qtyPicked || 0)" :min="0" :max="Number(item.qtyToPick || item.outboundQty || 0)" :precision="6" style="width:110px" @change="value => updatePicked(item, value)" />
                        <span v-else>{{ formatQty(item.qtyPicked) }}</span>
                      </td>
                      <td>{{ formatQty(item.qtyDiff) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="form.items.length" class="wave-pick-totals">
                <span>应拣合计：<b>{{ formatQty(displayTotalQtyToPick) }}</b></span>
                <span>实拣合计：<strong>{{ formatQty(displayTotalQtyPicked) }}</strong></span>
              </div>
            </section>
          </div>
        </div>
      </a-drawer>
    </div>
  </page-header-wrapper>
</template>

<script>
import { pageUser } from '@/api/system/user'
import { listWarehouse } from '@/api/erp/warehouse'
import { pageSalesOutbound, getSalesOutbound } from '@/api/erp/salesOutbound'
import {
  pageDeliveryWavePick,
  getDeliveryWavePick,
  listWavePickOutboundSources,
  listWavePickOutboundLines,
  createDeliveryWavePick,
  updateDeliveryWavePick,
  startWavePick,
  completeWavePickReview,
  deleteDeliveryWavePick,
  exportDeliveryWavePick
} from '@/api/erp/deliveryWavePick'
import { downloadPdfBlob, exportPdfFilename, printPdfBlob } from '@/utils/erpDeliveryPdf'

const blankForm = () => ({
  id: null,
  waveNo: '',
  outboundId: undefined,
  outboundIds: [],
  outboundNo: '',
  customerName: '',
  customerCode: '',
  warehouseId: undefined,
  warehouseName: '',
  tempZone: '',
  deliveryRoute: '',
  pickerUserId: undefined,
  planStartTime: undefined,
  reviewMethod: 'scan',
  pickStatus: 'pending_pick',
  totalQtyToPick: 0,
  totalQtyPicked: 0,
  remark: '',
  items: []
})

export default {
  name: 'ErpDeliveryWavePick',
  data () {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      readOnly: false,
      viewportWidth: window.innerWidth,
      form: blankForm(),
      lockedWarehouseId: undefined,
      userOptions: [],
      warehouses: [],
      rows: [],
      dateRange: [],
      selectedRowKeys: [],
      exporting: false,
      exportingId: null,
      printingId: null,
      outboundPickerVisible: false,
      outboundPickerKeyword: '',
      outboundPickerLoading: false,
      outboundPickerConfirming: false,
      outboundPickerRows: [],
      pickerWarehouseId: undefined,
      pickerSelectedKeys: [],
      pickerSelectedRows: [],
      outboundPickerMode: 'create',
      statusOptions: [
        { value: 'pending_pick', label: '待拣货' },
        { value: 'picking', label: '拣货中' },
        { value: 'reviewed', label: '已复核' },
        { value: 'completed', label: '已完成' }
      ],
      query: { waveNo: '', outboundNo: '', customerKeyword: '', pickStatus: undefined, pickerUserId: undefined, warehouseId: undefined },
      pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      outboundPickerColumns: [
        { title: '日期', dataIndex: 'outboundDate', width: 110 },
        { title: '出库单号', dataIndex: 'outboundNo', width: 170 },
        { title: '客商名称', dataIndex: 'customerName', width: 160, scopedSlots: { customRender: 'text' } },
        { title: '来源销售订单', dataIndex: 'sourceOrderNo', width: 170, scopedSlots: { customRender: 'text' } },
        { title: '仓库', dataIndex: 'warehouseName', width: 140, scopedSlots: { customRender: 'text' } },
        { title: '出库数量', dataIndex: 'outboundQty', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '折后实际金额', dataIndex: 'actualAmount', width: 130, scopedSlots: { customRender: 'money' } },
        { title: '审核状态', dataIndex: 'auditStatus', width: 100, scopedSlots: { customRender: 'auditStatus' } },
        { title: '业务员', dataIndex: 'salesUserName', width: 110, scopedSlots: { customRender: 'text' } }
      ],
      columns: [
        { title: '波次号', dataIndex: 'waveNo', width: 170, scopedSlots: { customRender: 'number' } },
        { title: '状态', dataIndex: 'pickStatus', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '来源出库单', dataIndex: 'outboundNo', width: 170 },
        { title: '客户', dataIndex: 'customerName', width: 140 },
        { title: '仓库', dataIndex: 'warehouseName', width: 120 },
        { title: '温区', dataIndex: 'tempZone', width: 90 },
        { title: '线路', dataIndex: 'deliveryRoute', width: 120 },
        { title: '拣货员', dataIndex: 'pickerUserName', width: 100 },
        { title: '计划开始', dataIndex: 'planStartTime', width: 160, scopedSlots: { customRender: 'planStart' } },
        { title: '应拣合计', dataIndex: 'totalQtyToPick', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '实拣合计', dataIndex: 'totalQtyPicked', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '操作', key: 'actions', fixed: 'right', width: 360, scopedSlots: { customRender: 'actions' } }
      ]
    }
  },
  computed: {
    drawerWidth () { return this.viewportWidth > 1500 ? 1080 : '96vw' },
    editable () { return !this.readOnly && (this.form.pickStatus === 'pending_pick' || this.form.pickStatus === 'picking') },
    editableDraft () { return !this.readOnly && this.form.pickStatus === 'pending_pick' },
    canEditPicked () { return !this.readOnly && (this.form.pickStatus === 'pending_pick' || this.form.pickStatus === 'picking') },
    warehouseOptions () {
      return (this.warehouses || []).map(row => ({
        id: String(row.id),
        name: row.warehouseName || '',
        label: [row.warehouseCode, row.warehouseName].filter(Boolean).join(' · ') || '未命名仓库'
      }))
    },
    formWarehouseOptions () {
      const options = this.warehouseOptions.slice()
      const current = this.normalizeWarehouseId(this.form.warehouseId)
      if (current && !options.some(row => row.id === current)) {
        options.unshift({ id: current, name: this.form.warehouseName || '', label: this.form.warehouseName || '已选仓库' })
      }
      return options
    },
    displayTotalQtyToPick () {
      if (!this.form.items.length) return this.form.totalQtyToPick || 0
      return this.form.items.reduce((sum, row) => sum + Number(row.qtyToPick || row.outboundQty || 0), 0)
    },
    displayTotalQtyPicked () {
      if (!this.form.items.length) return this.form.totalQtyPicked || 0
      return this.form.items.reduce((sum, row) => sum + Number(row.qtyPicked || 0), 0)
    },
    outboundPickerRowSelection () {
      const self = this
      return {
        type: 'checkbox',
        selectedRowKeys: self.pickerSelectedKeys,
        onChange (keys) {
          self.pickerSelectedKeys = (keys || []).map(key => String(key))
          self.pickerSelectedRows = self.pickerSelectedRowsFromKeys()
        }
      }
    },
    rowSelection () {
      const self = this
      return {
        selectedRowKeys: self.selectedRowKeys,
        onChange (keys) {
          self.selectedRowKeys = (keys || []).map(key => String(key))
        }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    pageUser({ pageNum: 1, pageSize: 200 }).then(res => { this.userOptions = (res.data && res.data.records) || [] })
    listWarehouse(true).then(res => { this.warehouses = res.data || [] })
    this.load()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    rowKey (record) { return String(record.id) },
    pickerRowKey (record) { return String(record.outboundId || record.id || '') },
    pickerSelectedRowsFromKeys () {
      return (this.pickerSelectedKeys || []).map(key => (
        this.outboundPickerRows.find(row => String(row.outboundId || row.id) === String(key))
      )).filter(Boolean)
    },
    normalizeOutboundPickerRow (row, orderMap) {
      const outboundId = String(row.outboundId || row.id || '')
      const matches = orderMap[outboundId] || []
      const sourceOrderNo = row.sourceOrderNo || Array.from(new Set(matches.map(item => item.sourceOrderNo).filter(Boolean))).join('、')
      const salesUserName = row.salesUserName || Array.from(new Set(matches.map(item => item.salesUserName).filter(Boolean))).join('、')
      const warehouseName = row.warehouseName || this.warehouseNameById(row.warehouseId)
      return Object.assign({}, row, { outboundId: row.outboundId || row.id, sourceOrderNo, salesUserName, warehouseName })
    },
    onResize () { this.viewportWidth = window.innerWidth },
    normalizeWarehouseId (value) {
      if (value === null || value === undefined || value === '') return undefined
      return String(value)
    },
    formatQty (value) {
      const num = Number(value || 0)
      return Number.isInteger(num) ? String(num) : num.toFixed(6).replace(/\.?0+$/, '')
    },
    formatMoney (value) { return Number(value || 0).toFixed(2) },
    auditStatusText (value) { return ({ unaudited: '未审核', audited: '已审核', reverse_audited: '已反审核' })[value] || (value || '—') },
    statusText (value) {
      const hit = this.statusOptions.find(o => o.value === value)
      return hit ? hit.label : (value || '—')
    },
    statusColor (value) {
      if (value === 'reviewed' || value === 'completed') return 'green'
      if (value === 'picking') return 'blue'
      return 'orange'
    },
    statusHint (value) {
      if (value === 'picking') return '拣货中：可继续修改实拣数量，保存后执行复核完成。'
      if (value === 'reviewed') return '已复核；复核数量需与实拣数量一致，差异已写入明细。'
      if (value === 'pending_pick') return '待拣货：选择出库单后可直接填写实拣数量，保存后生成波次。'
      return '波次作业凭证，继承来源出库数量，不新建成交价格。'
    },
    buildQuery () {
      const params = Object.assign({}, this.query, {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      if (this.dateRange && this.dateRange.length === 2) {
        params.dateStart = this.dateRange[0].format('YYYY-MM-DD')
        params.dateEnd = this.dateRange[1].format('YYYY-MM-DD')
      }
      return params
    },
    load () {
      this.loading = true
      pageDeliveryWavePick(this.buildQuery()).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = Number(page.total || 0)
      }).finally(() => { this.loading = false })
    },
    search () { this.pagination.current = 1; this.load() },
    reset () {
      this.query = { waveNo: '', outboundNo: '', customerKeyword: '', pickStatus: undefined, pickerUserId: undefined, warehouseId: undefined }
      this.dateRange = []
      this.selectedRowKeys = []
      this.search()
    },
    pdfBlobFromResponse (res) {
      return (res && res.data !== undefined ? res.data : res)
    },
    async doExport () {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先勾选要导出的波次拣货单')
        return
      }
      this.exporting = true
      try {
        const ids = this.selectedRowKeys.map(id => (id != null ? String(id) : id))
        const res = await exportDeliveryWavePick(ids)
        await downloadPdfBlob(this.pdfBlobFromResponse(res), exportPdfFilename('拣货确认单'))
      } catch (e) {
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exporting = false
      }
    },
    async exportRow (record) {
      const id = record && record.id != null ? String(record.id) : ''
      if (!id) return
      this.exportingId = id
      try {
        const res = await exportDeliveryWavePick([id])
        const prefix = record.waveNo ? `拣货确认单_${record.waveNo}` : '拣货确认单'
        await downloadPdfBlob(this.pdfBlobFromResponse(res), exportPdfFilename(prefix))
      } catch (e) {
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportingId = null
      }
    },
    async printRow (record) {
      const id = record && record.id != null ? String(record.id) : ''
      if (!id) return
      this.printingId = id
      try {
        const res = await exportDeliveryWavePick([id])
        await printPdfBlob(this.pdfBlobFromResponse(res))
      } catch (e) {
        this.$message.error((e && e.message) || '打印失败')
      } finally {
        this.printingId = null
      }
    },
    onPageChange (pager) {
      this.pagination.current = pager.current
      this.pagination.pageSize = pager.pageSize
      this.load()
    },
    openCreate () {
      this.form = blankForm()
      this.lockedWarehouseId = undefined
      this.readOnly = false
      this.drawerVisible = true
    },
    onFormWarehouseChange (warehouseId) {
      const normalized = this.normalizeWarehouseId(warehouseId)
      const hit = this.warehouseOptions.find(row => row.id === normalized)
      this.form.warehouseId = normalized
      this.form.warehouseName = hit ? hit.name : (normalized ? this.form.warehouseName : '')
      if (!this.form.outboundIds.length) {
        this.lockedWarehouseId = normalized
        return
      }
      if (String(normalized || '') !== String(this.lockedWarehouseId || '')) {
        this.clearOutboundSelection()
        this.lockedWarehouseId = normalized
      }
    },
    clearOutboundSelection () {
      this.form.outboundIds = []
      this.form.outboundId = undefined
      this.form.outboundNo = ''
      this.form.customerName = ''
      this.form.customerCode = ''
      this.form.items = []
      this.form.totalQtyToPick = 0
      this.form.totalQtyPicked = 0
    },
    openOutboundPicker (mode) {
      this.outboundPickerMode = mode || 'change'
      this.pickerWarehouseId = this.form.warehouseId
      this.pickerSelectedKeys = (this.form.outboundIds || []).map(id => String(id))
      this.pickerSelectedRows = []
      this.outboundPickerKeyword = ''
      this.outboundPickerVisible = true
      this.loadOutboundPickerList()
    },
    onPickerWarehouseChange (warehouseId) {
      this.pickerWarehouseId = this.normalizeWarehouseId(warehouseId)
      this.pickerSelectedKeys = []
      this.pickerSelectedRows = []
      this.loadOutboundPickerList()
    },
    warehouseNameById (warehouseId) {
      const id = this.normalizeWarehouseId(warehouseId)
      const warehouse = this.warehouseOptions.find(item => item.id === id)
      return warehouse ? warehouse.name : ''
    },
    loadOutboundPickerList () {
      const params = { keyword: this.outboundPickerKeyword || '' }
      if (this.pickerWarehouseId) params.warehouseId = this.pickerWarehouseId
      if (this.form.id) params.excludeWaveId = this.form.id
      this.outboundPickerLoading = true
      const sourceReq = listWavePickOutboundSources(params)
      const orderReq = pageSalesOutbound({
        pageNum: 1,
        pageSize: 500,
        auditStatus: 'audited',
        warehouseId: this.pickerWarehouseId || undefined
      }).catch(() => ({ data: { records: [] } }))
      return Promise.all([sourceReq, orderReq]).then(([res, orderRes]) => {
        const orders = ((orderRes.data || {}).records) || []
        const orderMap = {}
        orders.forEach(item => {
          const id = String(item.id)
          if (!orderMap[id]) orderMap[id] = []
          orderMap[id].push(item)
        })
        this.outboundPickerRows = (res.data || []).map(row => this.normalizeOutboundPickerRow(row, orderMap))
        this.pickerSelectedRows = this.pickerSelectedRowsFromKeys()
      }).catch(err => {
        this.outboundPickerRows = []
        this.$message.error((err && err.message) || '加载可拣出库单失败，请检查登录状态或权限')
        return Promise.reject(err)
      }).finally(() => { this.outboundPickerLoading = false })
    },
    applyOutboundSources (selectedRows) {
      const warehouseIds = Array.from(new Set(selectedRows.map(row => String(row.warehouseId))))
      if (warehouseIds.length > 1) {
        this.$message.warning('请选择同一仓库下的销售出库单')
        return false
      }
      const first = selectedRows[0]
      this.form.outboundIds = selectedRows.map(row => row.outboundId)
      this.form.outboundId = first.outboundId
      this.form.outboundNo = selectedRows.map(row => row.outboundNo).join('、')
      this.form.customerName = Array.from(new Set(selectedRows.map(row => row.customerName).filter(Boolean))).join('、')
      this.form.customerCode = Array.from(new Set(selectedRows.map(row => row.customerCode).filter(Boolean))).join('、')
      this.lockedWarehouseId = this.normalizeWarehouseId(first.warehouseId)
      this.form.warehouseId = this.lockedWarehouseId
      this.form.warehouseName = first.warehouseName || this.warehouseNameById(first.warehouseId)
      this.form.tempZone = first.tempZone || ''
      const route = selectedRows.map(row => row.deliveryRoute).find(Boolean)
      if (route && !this.form.deliveryRoute) this.form.deliveryRoute = route
      return true
    },
    loadOutboundLinesForForm () {
      if (!this.form.outboundIds.length) {
        this.form.items = []
        return Promise.resolve()
      }
      const pickedMap = {}
      this.form.items.forEach(row => { pickedMap[String(row.outboundItemId)] = row.qtyPicked })
      const sourceMap = {}
      ;(this.pickerSelectedRows || []).forEach(row => { sourceMap[String(row.outboundId)] = row })
      return Promise.all(this.form.outboundIds.map(id => listWavePickOutboundLines(id, this.form.id).then(res => {
        const source = sourceMap[String(id)] || {}
        return (res.data || []).map(row => Object.assign({}, row, {
          outboundId: row.outboundId || source.outboundId || id,
          outboundNo: row.outboundNo || source.outboundNo || '',
          sourceOrderNo: row.sourceOrderNo || source.sourceOrderNo || '',
          outboundQty: row.outboundQty != null ? row.outboundQty : row.qtyBusiness,
          qtyToPick: row.qtyToPick != null ? row.qtyToPick : (row.outboundQty != null ? row.outboundQty : row.qtyBusiness)
        }))
      }))).then(groups => {
        this.form.items = groups.reduce((all, rows) => all.concat(rows), []).map(row => {
          const picked = pickedMap[String(row.outboundItemId)]
          return Object.assign({}, row, { qtyPicked: picked == null ? Number(row.qtyPicked || 0) : Number(picked) })
        })
        this.form.totalQtyToPick = this.form.items.reduce((sum, row) => sum + Number(row.qtyToPick || row.outboundQty || 0), 0)
        this.form.totalQtyPicked = this.form.items.reduce((sum, row) => sum + Number(row.qtyPicked || 0), 0)
        return this.enrichLineDisplay()
      })
    },
    updatePicked (item, value) {
      item.qtyPicked = value == null ? 0 : Number(value)
      this.form.totalQtyPicked = this.form.items.reduce((sum, row) => sum + Number(row.qtyPicked || 0), 0)
    },
    enrichLineDisplay () {
      const ids = Array.from(new Set((this.form.outboundIds || []).concat(this.form.outboundId ? [this.form.outboundId] : []).filter(id => id && String(id) !== '0')))
      if (!ids.length || !this.form.items.length) return Promise.resolve()
      return Promise.all(ids.map(id => getSalesOutbound(id).catch(() => null))).then(responses => {
        const byItem = {}
        const bySku = {}
        responses.forEach(res => {
          const data = (res && res.data) || {}
          ;(data.items || []).forEach(item => {
            const display = {
              outboundNo: data.outboundNo || '',
              sourceOrderNo: item.sourceOrderNo || '',
              unitName: item.unitName || '',
              specName: item.specName || ''
            }
            byItem[String(item.id)] = display
            if (item.skuCode && !bySku[item.skuCode]) bySku[item.skuCode] = display
          })
        })
        this.form.items = this.form.items.map(row => {
          const extra = byItem[String(row.outboundItemId)] || bySku[row.skuCode] || {}
          return Object.assign({}, row, {
            outboundNo: row.outboundNo || extra.outboundNo || '',
            sourceOrderNo: row.sourceOrderNo || extra.sourceOrderNo || '',
            unitName: row.unitName || extra.unitName || '',
            specName: row.specName || extra.specName || ''
          })
        })
      })
    },
    confirmOutboundPicker () {
      const selectedRows = this.pickerSelectedRowsFromKeys()
      this.pickerSelectedRows = selectedRows
      if (!selectedRows.length) {
        this.$message.warning('请至少选择一张销售出库单')
        return Promise.reject(new Error('no selection'))
      }
      if (!this.applyOutboundSources(selectedRows)) {
        return Promise.reject(new Error('mixed warehouse'))
      }
      this.outboundPickerConfirming = true
      return this.loadOutboundLinesForForm().then(() => {
        if (!this.form.items.length) {
          this.$message.warning('所选销售出库单没有可拣货明细')
          return Promise.reject(new Error('empty lines'))
        }
        this.outboundPickerVisible = false
        this.readOnly = false
        this.drawerVisible = true
      }).finally(() => { this.outboundPickerConfirming = false })
    },
    fillForm (data) {
      const outboundIds = (data.outboundIds && data.outboundIds.length)
        ? data.outboundIds.slice()
        : (data.outboundId ? [data.outboundId] : [])
      this.lockedWarehouseId = data.warehouseId
      this.form = Object.assign(blankForm(), data, {
        outboundIds,
        items: (data.items || []).map(row => Object.assign({}, row, { qtyPicked: Number(row.qtyPicked || 0) }))
      })
    },
    openDetail (record, edit) {
      getDeliveryWavePick(record.id).then(res => {
        this.fillForm(res.data || {})
        this.readOnly = !edit
        this.drawerVisible = true
        return this.enrichLineDisplay()
      })
    },
    closeDrawer () { this.drawerVisible = false },
    save () {
      if (!this.form.outboundIds.length) {
        this.$message.warning('请先选择销售出库单')
        return
      }
      if (!this.form.items.length) {
        this.$message.warning('拣货明细为空，请重新选择销售出库单')
        return
      }
      const payload = {
        id: this.form.id || undefined,
        outboundId: this.form.outboundId || this.form.outboundIds[0],
        outboundIds: this.form.outboundIds.slice(),
        warehouseId: this.form.warehouseId || undefined,
        deliveryRoute: this.form.deliveryRoute,
        pickerUserId: this.form.pickerUserId,
        planStartTime: this.form.planStartTime,
        reviewMethod: this.form.reviewMethod,
        remark: this.form.remark,
        items: this.form.items.map(row => ({
          id: row.id || undefined,
          outboundItemId: row.outboundItemId,
          qtyPicked: row.qtyPicked
        }))
      }
      this.saving = true
      const request = this.form.id ? updateDeliveryWavePick(payload) : createDeliveryWavePick(payload)
      request.then(res => {
        this.$message.success(this.form.id ? '波次拣货单已保存' : '波次拣货单已创建')
        this.fillForm(res.data || {})
        this.readOnly = this.form.pickStatus !== 'pending_pick' && this.form.pickStatus !== 'picking'
        this.load()
        return this.enrichLineDisplay()
      }).finally(() => { this.saving = false })
    },
    confirmAction (label, record, action) {
      const self = this
      this.$confirm({
        title: label + ' · ' + record.waveNo,
        content: '确认执行「' + label + '」？',
        onOk () {
          return action(record.id).then(() => {
            self.$message.success(label + '成功')
            self.load()
            if (self.drawerVisible && self.form.id === record.id) {
              getDeliveryWavePick(record.id).then(res => {
                self.fillForm(res.data || {})
                self.readOnly = label === '复核完成' || label === '开始拣货'
                if (label === '开始拣货') self.readOnly = false
              })
            }
          })
        }
      })
    },
    startWavePick,
    completeWavePickReview,
    deleteDeliveryWavePick
  }
}
</script>

<style scoped>
.wave-pick-page .erp-drawer-shell {
  padding-bottom: 22px;
}
.wave-pick-page .wave-pick-line-table { min-width: 1100px; }
.wave-pick-page .wave-pick-totals {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}
.wave-pick-page .erp-line-table-wrap { overflow-x: auto; }
.wave-pick-picker-tip {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.5;
}
.wave-pick-picker-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  align-items: center;
  flex-wrap: wrap;
}
.wave-pick-picker-label { color: rgba(0, 0, 0, 0.85); }
.wave-pick-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.wave-pick-reselect {
  flex: none;
  height: 32px;
  padding: 0 14px;
  border-color: #91caff;
  color: #1677ff;
  background: #f0f7ff;
  border-radius: 4px;
}
.wave-pick-reselect:hover,
.wave-pick-reselect:focus {
  border-color: #1677ff;
  color: #0958d9;
  background: #e6f4ff;
}
.wave-pick-outbound-field {
  display: flex;
  align-items: center;
  gap: 4px;
}
.wave-pick-outbound-field .ant-input { flex: 1; }
</style>
